/**
 * Omnivoip Audio Manager
 * Routes audio connections to the correct provider based on server_type.
 * To add a new provider, create a new file and register it in the switch.
 */

import * as goMD from './goMD'

const providers = {
    goMD,
}

let activeProvider = null

function getProvider(serverType) {
    return providers[serverType] || null
}

/**
 * @param {string} serverType - e.g. 'goMD'
 */
export function preWarmAudio(serverType) {
    const provider = getProvider(serverType)
    if (provider?.preWarm) {
        provider.preWarm()
    } else {
        console.warn('[OmnivoipAudio] No preWarm for server type:', serverType)
    }
}

/**
 * @param {string} serverType - e.g. 'goMD'
 * @param {string} serverUrl
 * @param {string} apiId - canal/server ID
 * @param {string} callId
 */
export function startAudio(serverType, serverUrl, apiId, callId) {
    if (!serverType || !serverUrl || !callId) {
        console.warn('[OmnivoipAudio] Missing params:', { serverType, serverUrl, apiId, callId })
        return
    }

    if (activeProvider) {
        activeProvider.disconnect()
        activeProvider = null
    }

    const provider = getProvider(serverType)
    if (provider) {
        provider.connect(serverUrl, apiId, callId)
        activeProvider = provider
    } else {
        console.warn('[OmnivoipAudio] Unknown server type:', serverType)
    }
}

export function stopAudio() {
    if (activeProvider) {
        activeProvider.disconnect()
        activeProvider = null
    }
}

export function isAudioConnected() {
    return activeProvider?.isConnected() ?? false
}
